<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <div class="map-search-container wrap1200">
            <div id="map-container"></div>
            <div class="search-box">
            <input
                v-model="searchKeyword"
                type="text"
                placeholder="输入地点名称"
                @keyup.enter="handleSearch"
            />
            <button @click="handleSearch">搜索</button>
            <ul v-if="searchResults.length" class="result-list">
                <li
                  v-for="(item, index) in searchResults"
                  :key="index"
                  @click="selectLocation(item)"
                >
                  {{ item.name }} - {{ item.address }}
                </li>
            </ul>
            </div>
        </div>
    </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import Breadcrumb from '../components/Breadcrumb.vue';
window._AMapSecurityConfig = {
  securityJsCode: 'df4b2da8b0851eb4c22c842a228f6e87'
}
export default {
  name: 'App',
  components: {
      Breadcrumb
  },
  data() {
      return {
      map: null,
      placeSearch: null,
      searchKeyword: '',
      searchResults: [],
      AMap: null
      }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    async initMap() {
      try {
        this.AMap = await AMapLoader.load({
          key: '06cd2d79191a9bff3a31a4609d42c3e4', // 你的高德地图Key
          version: '2.0',
          plugins: ['AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.Geocoder'],
          // 添加安全密钥配置（从高德控制台获取）
          // securityJsCode: 'df4b2da8b0851eb4c22c842a228f6e87', // 替换为你的安全密钥
        });
        
        // 初始化地图
        this.map = new this.AMap.Map('map-container', {
          viewMode: '2D',
          zoom: 12,
          center: [116.397428, 39.90923] // 默认北京中心点
        })
        
        // 初始化地点搜索插件
        this.placeSearch = new this.AMap.PlaceSearch({
          map: this.map,
          pageSize: 5,
          pageIndex: 1
        })
        
        // 监听搜索完成事件
        this.placeSearch.on('complete', (data) => {
          console.log(data,'data')
          this.searchResults = data.poiList.pois
        })
        
        // 监听搜索错误事件
        this.placeSearch.on('error', (error) => {
          console.error('搜索出错:', error)
          this.searchResults = []
        })
        console.log(this.placeSearch,'this.placeSearch')
      } catch (error) {
        console.error('地图初始化失败:', error)
      }
    },
      
    handleSearch() {
      if (!this.searchKeyword.trim()) return
      this.placeSearch.search(this.searchKeyword)
    },
      
    selectLocation(item) {
      // 定位到选中的地点
      this.map.setCenter([item.location.lng, item.location.lat])
      this.map.setZoom(16)
      this.searchResults = []
      this.searchKeyword = item.name
      
      // 可以在这里触发事件，将选中的位置信息传递给父组件
      this.$emit('location-selected', {
        name: item.name,
        address: item.address,
        lng: item.location.lng,
        lat: item.location.lat
      })
    }
  }
}
</script>
<style scoped>
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.map-search-container {
  /* position: relative; */
  /* width: 100%; */
  height: 500px;
}

#map-container {
  width: 100%;
  height: 100%;
}

.search-box {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.search-box input {
  padding: 8px;
  width: 250px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.search-box button {
  padding: 8px 15px;
  margin-left: 5px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.result-list {
  list-style: none;
  padding: 0;
  margin-top: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.result-list li {
  padding: 8px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.result-list li:hover {
  background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/views/map.vue